export default function is_consent_google_maps() {
  // Anpassung, falls Cookiebot an ist.
  // Hier muss verhindert werden, dass bereits gesetzte Cookies von Enfold, Cookiebot behindern.
  const tmp_cookie_bot = window.Cookiebot || "";
  if ("" !== tmp_cookie_bot) {
    // Hier direkt False zurückgeben, damit alte Enfold Cookies sicht nicht einmischen..
    return false;
  }

  // CCM berücksichtigen.
  if (window.CCM) {
    return false;
  }

  var current_google_cookie = geowerft_get_cookie_by_name(
    "aviaPrivacyGoogleMapsDisabled"
  );
  var current_consent_cookie = geowerft_get_cookie_by_name("aviaCookieConsent");

  if ("empty" !== current_consent_cookie && "empty" === current_google_cookie) {
    return true;
  }
  return false;
}

function geowerft_get_cookie_by_name(cookie_name) {
  var name = cookie_name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookie_list = decodedCookie.split(";");
  var len = cookie_list.length;
  for (var i = 0; i < len; i++) {
    var current_cookie = cookie_list[i];
    while (current_cookie.charAt(0) === " ") {
      current_cookie = current_cookie.substring(1);
    }
    if (current_cookie.indexOf(name) === 0) {
      return current_cookie.substring(name.length, current_cookie.length);
    }
  }
  return "empty";
}



// WEBPACK FOOTER //
// ./src/check-consent.js